import { Typography } from "@/components/shared/typography";
import { formatNumber } from "@/lib/helpers/number";
import { View } from "@/components/ui";
import { Star } from "@/components/shared/icons";

type CustomerReviewRatingProps = {
  averageRating: number;
  total: number;
};

export const CustomerReviewRating = ({
  averageRating,
  total,
}: CustomerReviewRatingProps) => {
  return (
    <View className="flex flex-row items-center gap-2">
      <Star weight="fill" className="text-amber-500" size={20} />
      <Typography variant="label-sm">{averageRating.toFixed(1)}/5.0</Typography>
      <Typography variant="body-sm" color="foreground-default">
        |
      </Typography>
      <Typography variant="label-sm">{formatNumber(total)} Rating</Typography>
    </View>
  );
};
